(function () {
    'use strict';

    angular
        .module('portalApp')
        .directive('timeseriesChart', timeseriesChart);

    timeseriesChart.$inject = ['$window', 'chartConfig', 'TimeseriesUtils', 'DateUtils', 'OgrChart'];

    function timeseriesChart($window, chartConfig, TimeseriesUtils, DateUtils, OgrChart) {
        // Generates chart for one or more timeseries
        // Usage:
        //  <div data-timeseries-chart chart-data="vm.chartData">
        //  <div data-timeseries-chart chart-data="vm.chartData" line-style="vm.lineStyle">
        //  <div data-timeseries-chart chart-data="vm.chartData" date-format="vm.dateFormat" date-frequency="vm.dateFreq">
        //  <div data-timeseries-chart chart-data="vm.chartData" shadow-range="vm.shadowRange">
        //  <div data-timeseries-chart chart-data="vm.chartData" min-date="vm.minimumDate">
        //  <div data-timeseries-chart chart-data="vm.chartData" max-date="vm.maximumDate">
        //  <div data-timeseries-chart chart-data="vm.chartData" y-label="vm.country.currency.code + ' per USD'">
        // Input structure:
        //  vm.chartData = {
        //      chartId: "someId",
        //      title: "some title",
        //      lineSeries: [
        //          [
        //              {date: Date, value: Double},
        //              ...
        //          ],
        //          ...
        //      ]
        //  }
        //  vm.lineStyle = [
        //      {
        //          width: 2,
        //          color: '#3734FF',
        //          dashSetting: [<dashWidth>,<emptySpaceWidth>],
        //          markerSize: 2,
        //      },
        //      ...
        //  ]
        //  vm.shadowRange = [
        //      {
        //          start: Date,
        //          end: Date,
        //          color: '#373737',
        //          opacity: 0.5
        //      },
        //      ...
        //  ]
        // Creates:
        //  <div data-dd-timeseries-chart class="timeseriesChart">
        var directive = {
            link: linkFunc,
            restrict: 'A',
            scope: {
                chartData: '<',
                lineStyle: '<',
                lineWidth: '<',
                dateFormat: '<',
                dateFrequency: '<',
                shadowRange: '<',
                minDate: '<',
                maxDate: '<',
                yLabel: '<'
            }
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.addClass('timeseriesChart');
            element.attr('id', scope.chartData.chartId);

            makeChart();

            scope.$watch('chartData', updateChart, true);
            scope.$watch('lineStyle', updateChart, true);
            scope.$watch('lineWidth', updateChart, true);
            scope.$watch('dateFormat', updateChart, true);
            scope.$watch('dateFrequency', updateChart, true);
            scope.$watch('shadowRange', updateChart, true);
            scope.$watch('minDate', updateChart, true);
            scope.$watch('maxDate', updateChart, true);
            scope.$watch('yLabel', updateChart, true);
            scope.$watch(parentWidth,
                function (newVal, oldVal) {
                    // update chart after all the other stuff listening to
                    // the change of width of the parent div is done, 1 sec is enough
                    setTimeout(function () {
                        updateChart(newVal, oldVal);
                    }, 1000);
                },
                true);
            //some responsiveness here: when window was resized - recalculate
            // height of the chart based on the parent height
            var win = angular.element($window);
            win.bind("resize", updateChart);
            element.on('$destroy', function () {
                win.unbind("resize", updateChart);
            });

            function parentWidth() {
                return {
                    width: element.parent().width()
                };
            }

            function updateChart(newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                //unbind this function before removing the chart
                win.unbind("resize", updateChart);
                OgrChart.destroy(element);
                element.empty();
                makeChart();
                win.bind("resize", updateChart);
            }

            function makeChart() {
                // console.log('here!');
                //load defaults
                var chartObject = angular.copy(chartConfig.timeseriesChartDefaults.chartObject);
                var defaultLineStyles = angular.copy(chartConfig.timeseriesChartDefaults.lineStyles);
                var defaultDateFormat = angular.copy(chartConfig.timeseriesChartDefaults.dateFormat);
                var defaultFrequency = angular.copy(chartConfig.timeseriesChartDefaults.frequency);
                var defaultShadowStyle = angular.copy(chartConfig.timeseriesChartDefaults.shadowStyle);

                //get chart title from chartData
                // chartObject.title.text = angular.copy(scope.chartData.title);

                //get the label for Y-axis
                var yLabel = angular.copy(scope.yLabel);
                if (!yLabel)
                    yLabel = "";

                //get lines' series from chartData
                var lineData = angular.copy(scope.chartData.lineSeries);

                // confidence bands data
                var bandWidthData = angular.copy(scope.chartData.lineBands);

                //try getting lines' styles from lineStyle
                var lineStyles = angular.copy(scope.lineStyle);

                //try getting lines' styles from lineStyle
                var lineWidths = angular.copy(scope.lineWidth);

                //get lines' legends from chartData
                var lineLegends = angular.copy(scope.chartData.lineLegends);

                //try getting tick labels' date format from dateFormat
                var dateFormat = angular.copy(scope.dateFormat);
                if (!dateFormat)
                    dateFormat = defaultDateFormat;

                //try getting tick labels' date frequency from dateFrequency
                var dateFrequency = angular.copy(scope.dateFrequency);
                if (!dateFrequency)
                    dateFrequency = defaultFrequency;

                //try getting shadow range from shadowRange
                var shadowRange = angular.copy(scope.shadowRange);
                if (!shadowRange)
                    shadowRange = [];

                //try getting minimum date from minDate
                var minDate = angular.copy(scope.minDate);

                //try getting maximum date from maxDate
                var maxDate = angular.copy(scope.maxDate);

                //update chart height based on the height of the parent element
                // console.log(element.parent().height());
                chartObject.height = element.parent().height();

                //if there was an error don't try to build a chart
                if (lineData === null) {
                    element.append('<p>Unable to plot the chart</p>');
                    return;
                }

                //if there's no line styles provided fill them in with the default line styles
                var ix;
                if (lineData.length > 0 && (!lineStyles || lineStyles.length == 0)) {
                    lineStyles = [];
                    for (ix = 0; ix < Math.min(6, lineData.length); ix++) {
                        lineStyles.push(defaultLineStyles.predefined[ix]);
                    }
                }

                //if line data is empty show the "Empty" message
                if (lineData.length == 0) {
                    chartObject.placeholder.show = true;
                    chartObject.xAxis.show = false;
                    chartObject.yAxis.show = false;
                    chartObject.xAxis.grid = false;
                    chartObject.yAxis.grid = false;
                    chartObject.yAxis.title.show = false;
                    chartObject.series = [];
                    chartObject.xAxis.shading = [];
                    chartObject.legend.show = false;
                } else {
                    chartObject.placeholder.show = false;
                    chartObject.xAxis.show = true;
                    chartObject.yAxis.show = true;
                    chartObject.xAxis.grid = true;
                    chartObject.yAxis.grid = true;
                    chartObject.yAxis.title.show = true;
                    chartObject.yAxis.title.text = yLabel;
                    chartObject.series = [];
                    chartObject.xAxis.shading = [];
                    chartObject.legend.show = true;
                }
                //cut the range of all chart series
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        if (minDate)
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint))
                                    return false;
                                return new Date(dataPoint.date) >= minDate;
                            });
                        if (maxDate)
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint))
                                    return false;
                                return new Date(dataPoint.date) <= maxDate;
                            });
                    }
                }
                //configure shadow ranges
                if (lineData.length > 0)
                    for (ix = 0; ix < shadowRange.length; ix++) {
                        var ixc = angular.copy(ix);
                        var sr = angular.copy(shadowRange[ixc]);
                        sr.visible = true;
                        //todo: lineData[0] is a nasty assumption -- use the series which starts the earliest instead
                        if (shadowRange[ixc].start) {
                            var convertedDate = DateUtils.convertLocalDateToServer(
                                TimeseriesUtils.parseTsDate(
                                    TimeseriesUtils.convertDateToTsDate(shadowRange[ixc].start, dateFrequency, dateFormat), dateFrequency
                                )
                            );
                            sr.start = lineData[0].findIndex(function (d) {
                                return d.date == convertedDate;
                            });
                        } else {
                            sr.start = 0;
                        }
                        if (shadowRange[ixc].end) {
                            var convertedDate = DateUtils.convertLocalDateToServer(
                                TimeseriesUtils.parseTsDate(
                                    TimeseriesUtils.convertDateToTsDate(shadowRange[ixc].end, dateFrequency, dateFormat), dateFrequency
                                )
                            );
                            sr.end = lineData[0].findIndex(function (d) {
                                return d.date == convertedDate;
                            });
                        } else {
                            if (shadowRange[ixc].start) {
                                sr.end = lineData[0].length - 1;
                            } else {
                                sr.end = 0;
                            }
                        }
                        for (var styleProperty in defaultShadowStyle) {
                            if (defaultShadowStyle.hasOwnProperty(styleProperty) && !shadowRange[ixc].hasOwnProperty(styleProperty)) {
                                sr[styleProperty] = defaultShadowStyle[styleProperty];
                            }
                        }
                        chartObject.xAxis.shading.push({from: sr.start, to: sr.end, color: sr.color, opacity: sr.opacity});
                    }
                //fill in series of chartObject with the lines' data
                var minValue = Number.MAX_VALUE;
                var maxValue = -Number.MAX_VALUE;
                // first and last date label over all series (in text order), for the daily category axis
                var firstTick, lastTick;
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        var bandPoints = [];
                        const hasBand = (angular.isDefined(bandWidthData[ix]) && bandWidthData[ix] !== 0);
                        //convert dates to formatted date strings
                        for (var jx = 0; jx < lineData[ix].length; jx++) {
                            const yNum = lineData[ix][jx].value;
                            const dt = lineData[ix][jx].date;
                            minValue = Math.min(minValue, yNum);
                            maxValue = Math.max(maxValue, yNum);
                            lineData[ix][jx].dateFormatted = TimeseriesUtils.convertDateToTsDate(dt, dateFrequency, dateFormat);
                            const tick = lineData[ix][jx].dateFormatted;
                            if (firstTick === undefined || String(tick) < String(firstTick)) {
                                firstTick = tick;
                            }
                            if (lastTick === undefined || String(tick) > String(lastTick)) {
                                lastTick = tick;
                            }
                            if (hasBand) {
                                bandPoints.push({
                                    x: lineData[ix][jx].dateFormatted,
                                    upper: yNum + bandWidthData[ix],
                                    lower: yNum - bandWidthData[ix]
                                });
                            }
                        }
                        //use default line style if number of lines is higher the number of predefined lines in config
                        if (lineStyles.length < ix + 1) {
                            lineStyles.push(defaultLineStyles.new);
                        }
                        //adjust line width if user supplied one
                        if (lineWidths.length >= ix + 1 && lineWidths[ix]) {
                            lineStyles[ix].width = lineWidths[ix];
                        }
                        //use default legend if lineLegends array is shorter
                        var lineName = "";
                        if (!lineLegends || lineLegends.length < ix + 1) {
                            lineName = "curve" + (ix + 1);
                        } else {
                            lineName = lineLegends[ix];
                        }
                        // add confidence bands for lines
                        if (bandPoints.length > 0) {
                            chartObject.series.push({
                                kind: 'band',
                                color: '#dbdbe6',
                                tooltipFont: {color: '#1e2834'},
                                edgeColor: 'transparent',
                                points: bandPoints,
                                label: lineName + " ±1 stdev"
                            });
                        }
                        //add series to the chart structure
                        chartObject.series.push({
                            kind: 'line',
                            color: lineStyles[ix].color,
                            lineWidth: lineStyles[ix].width,
                            marker: {show: false, size: lineStyles[ix].markerSize},
                            dash: lineStyles[ix].dashSetting,
                            points: lineData[ix].map(function (d) {
                                return {x: d.dateFormatted, y: d.value};
                            }),
                            label: lineName
                        });
                    }
                }

                // add invisible series to the beginning of chartObject.series array
                // to correctly handle the X axis ticks
                var dataPoints = [];
                const endDate = new Date(lastTick);
                for (var d = new Date(firstTick); d <= endDate; d.setDate(d.getDate() + 1)) {
                    dataPoints.push({
                        x: TimeseriesUtils.convertDateToTsDate(d, dateFrequency, dateFormat),
                        y: -100
                    });
                }
                chartObject.series.unshift({
                    kind: 'line',
                    color: "transparent",
                    points: dataPoints,
                    label: " ",
                    // only supplies the daily x categories; OgrChart never draws or tracks it
                    axisOnly: true
                });
                // adjust X-axis interval to be at most 9 ticks
                const nTicks = dataPoints.length;
                chartObject.xAxis.step = Math.ceil(nTicks / 9);
                // adjust Y-axis range to be tight
                var delta = Math.abs(maxValue - minValue);
                if (lineData.length > 0) {
                    chartObject.yAxis.min = minValue - 0.1 * delta;
                    chartObject.yAxis.max = maxValue + 0.1 * delta;
                }
                // console.log(chartObject);
                //generate the chart from prepared object
                OgrChart.render(element, angular.copy(chartObject));
            }
        }
    }

})();
